import { render, staticRenderFns } from "./BlockDesigner.vue?vue&type=template&id=45a096ac"
import script from "./BlockDesigner.vue?vue&type=script&lang=js"
export * from "./BlockDesigner.vue?vue&type=script&lang=js"
import style0 from "./BlockDesigner.vue?vue&type=style&index=0&id=45a096ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports